module.exports = __webpack_public_path__ + "img/call.a4475e2b.svg";